import script from "./StudyReport.vue?vue&type=script&setup=true&lang=js"
export * from "./StudyReport.vue?vue&type=script&setup=true&lang=js"

import "./StudyReport.vue?vue&type=style&index=0&id=51bf628a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51bf628a"]])

export default __exports__